import { Outlet } from '@tanstack/react-router';

import { RandomBackground } from '../background';

export function LoginLayout(): React.ReactElement {
  const year = new Date().getFullYear();

  return (
    <RandomBackground>
      <Outlet />
      <footer className={'fixed bottom-0 w-full text-center my-7 text-sm'}>
        {`© ${year} CrossnoKaye Inc. All rights reserved. `}
        <a href={''}>{'Privacy Policy'}</a>
        {' |'}
        <a href={''}>{'Terms of Service'}</a>
      </footer>
    </RandomBackground>
  );
}
